import {AbstractModel, JsonObject, JsonProperty, DateConverter} from 'projects/core/src/public-api';


export interface ColumnConditionBlock {
  title: string;
  conditions: ColumnForEdit[]
}

@JsonObject('model.ColumnForEdit')
export class ColumnForEdit extends AbstractModel {

  @JsonProperty(Number, 'id')
  id: number;

  @JsonProperty(String, 'dbxFolder')
  dbxFolder?: string;

  @JsonProperty(Boolean, 'active')
  active?: boolean;

  @JsonProperty(Boolean, 'syncWithMainSystem')
  syncWithMainSystem?: boolean;

  @JsonProperty(Boolean, 'dbxGroupByYear')
  dbxGroupByYear?: boolean;

  @JsonProperty(String, 'name')
  name?: string;
}
